/* eslint-disable no-param-reassign */
import produce from 'immer';
var samplesValueInMetadataTrackUpdated = produce(function (draft, action) {
  var _action$payload = action.payload,
    key = _action$payload.key,
    updates = _action$payload.updates;
  updates.forEach(function (_ref) {
    var sampleIds = _ref.sampleIds,
      value = _ref.value;
    sampleIds.forEach(function (sampleId) {
      draft[sampleId].metadata[key] = value;
    });
  });
  draft.meta.saving = false;
  draft.meta.error = false;
});
export default samplesValueInMetadataTrackUpdated;